module.exports = "/images/vendor/flag-icon-css/flags/1x1/cc.svg?12b2a48420c7a24559f89dd27348b05a";